// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/pictures/signIn_background_img.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */
/* stylelint-disable no-duplicate-selectors */
/* stylelint-disable */
/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */
/* for components whose styles are define, those components will pick below two configurable colors */
/* 
 - for components whose styles are not defined, those components will pick below two default colors* 
 - add styles for those components if you want configurable colors.
 - @primary-color and @secondary-color cannot be changed because it is used by antd, if removed it will default to antd default primary and secondary color.
 - this is a workaround as antd core styles do not accept css variables as less variable values.
*/
::selection {
  background-color: var(--app-primary-color);
  color: #fff;
}
.index-module__signIn-form__IDQjg {
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 50vh;
  gap: 1rem;
}
.index-module__signIn-description__u7tes {
  font-size: 24px;
  font-weight: 600;
}
.index-module__version__I5b2y {
  display: flex;
  justify-content: center;
  align-items: center;
  color: gray;
  font-size: 12px;
  margin-top: -10px;
}
.index-module__signIn-form__password__L1g0c {
  margin-top: 4px;
}
.index-module__signIn-btn__qNKud {
  width: 100%;
  border-radius: 50px;
}
.index-module__forgot-password_div__OwfBo {
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-align: right;
  margin-bottom: 20px;
}
.index-module__forgot-password-text__GgDlJ {
  cursor: pointer;
  text-decoration: underline;
}
.index-module__recaptcha-container__RLebi {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 20px 0px;
  width: 100%;
}
.index-module__signIn-container__NoMaT {
  min-width: 100vw;
  max-width: 100%;
  min-height: 100vh;
  max-height: 100%;
  background-color: var(--app-primary-color);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}
.index-module__signIn-img__86wb7 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-position: center;
  display: flex;
  justify-content: center;
  align-items: center;
}
.index-module__signIn-form-logo-img__HQDP0 {
  width: 150px;
  height: 35px;
}
.index-module__signIn-form-card__EqlUE {
  width: 100%;
  margin: 10px;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  align-items: center;
  backdrop-filter: blur(15px);
  background-color: rgba(26, 91, 83, 0.16);
  border-radius: 15px;
  padding: 20px;
}
.index-module__signIn-form-container__hei_d {
  width: 100%;
  padding: 3% 18% 0% 18%;
}
.index-module__signIn-form-label-color__WhGVa {
  color: #ffffff;
}
.index-module__signIn-form-login_button__WSbsP {
  display: flex;
  justify-content: center;
  align-items: center;
}
.index-module__signIn-form-login_button_style__oYoTP {
  margin-top: 30px;
  width: 70%;
  color: var(--app-primary-color);
  font-size: 16px;
}
.index-module__signIn-form-login_text__AEDxc {
  cursor: pointer;
  color: #b5b5b5;
  text-decoration: underline;
}
.index-module__signIn-form-login_forgot_text__zfagw {
  cursor: pointer;
  color: #b5b5b5 !important;
  text-decoration: underline !important;
}
.index-module__signIn-form-login_forgot_text__zfagw:hover {
  color: var(--app-secondary-color) !important;
  cursor: pointer;
  text-decoration: underline;
}
.index-module__signIn-form-login_forgot_text__zfagw:active {
  color: var(--app-secondary-color) !important;
  cursor: pointer;
  text-decoration: underline;
}
.index-module__adani-logo__Ao0Rk {
  width: 120px;
}
.index-module__signIn_footer__eYVtO {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  margin-top: -1rem;
}
.index-module__signIn_footer-text__c6mRd {
  font-size: 14px;
  font-weight: 600;
}
/* large mobile */
@media only screen and (min-width: 600px) {
  .index-module__signIn-img__86wb7 {
    width: 70vh;
    height: 76vh;
  }
  .index-module__signIn-container__NoMaT {
    padding: 3% 0%;
  }
}
/* small mobile */
@media only screen and (min-width: 300px) and (max-width: 600px) {
  .index-module__signIn-img__86wb7 {
    width: 100%;
    height: 100%;
  }
  .index-module__signIn-container__NoMaT {
    padding: 20% 1%;
  }
  .index-module__signIn-form-card__EqlUE {
    margin: 20px;
  }
  .index-module__signIn-container__NoMaT {
    padding: 20% 0% 30% 0%;
  }
  .index-module__signIn-form-container__hei_d {
    padding: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/SignIn/index.module.less"],"names":[],"mappings":"AAAA,4FAA4F;AAC5F,6CAA6C;AAC7C,sBAAsB;AACtB,6FAA6F;AAC7F,qGAAqG;AACrG;;;;;CAKC;AACD;EACE,0CAA0C;EAC1C,WAAW;AACb;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;EAChB,SAAS;AACX;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA;EACE,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,yDAAwE;EACxE,sBAAsB;EACtB,2BAA2B;EAC3B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,wCAAwC;EACxC,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,WAAW;EACX,sBAAsB;AACxB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,UAAU;EACV,+BAA+B;EAC/B,eAAe;AACjB;AACA;EACE,eAAe;EACf,cAAc;EACd,0BAA0B;AAC5B;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,qCAAqC;AACvC;AACA;EACE,4CAA4C;EAC5C,eAAe;EACf,0BAA0B;AAC5B;AACA;EACE,4CAA4C;EAC5C,eAAe;EACf,0BAA0B;AAC5B;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA,iBAAiB;AACjB;EACE;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,cAAc;EAChB;AACF;AACA,iBAAiB;AACjB;EACE;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;EACd;EACA;IACE,sBAAsB;EACxB;EACA;IACE,UAAU;EACZ;AACF","sourcesContent":["/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable no-duplicate-selectors */\n/* stylelint-disable */\n/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */\n/* for components whose styles are define, those components will pick below two configurable colors */\n/* \n - for components whose styles are not defined, those components will pick below two default colors* \n - add styles for those components if you want configurable colors.\n - @primary-color and @secondary-color cannot be changed because it is used by antd, if removed it will default to antd default primary and secondary color.\n - this is a workaround as antd core styles do not accept css variables as less variable values.\n*/\n::selection {\n  background-color: var(--app-primary-color);\n  color: #fff;\n}\n.signIn-form {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  min-height: 50vh;\n  gap: 1rem;\n}\n.signIn-description {\n  font-size: 24px;\n  font-weight: 600;\n}\n.version {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: gray;\n  font-size: 12px;\n  margin-top: -10px;\n}\n.signIn-form__password {\n  margin-top: 4px;\n}\n.signIn-btn {\n  width: 100%;\n  border-radius: 50px;\n}\n.forgot-password_div {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  text-align: right;\n  margin-bottom: 20px;\n}\n.forgot-password-text {\n  cursor: pointer;\n  text-decoration: underline;\n}\n.recaptcha-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin: 20px 0px;\n  width: 100%;\n}\n.signIn-container {\n  min-width: 100vw;\n  max-width: 100%;\n  min-height: 100vh;\n  max-height: 100%;\n  background-color: var(--app-primary-color);\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: center;\n}\n.signIn-img {\n  background-image: url(\"../../assets/pictures/signIn_background_img.png\");\n  background-size: cover;\n  background-position: center;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.signIn-form-logo-img {\n  width: 150px;\n  height: 35px;\n}\n.signIn-form-card {\n  width: 100%;\n  margin: 10px;\n  display: flex;\n  justify-content: space-between;\n  flex-direction: column;\n  align-items: center;\n  backdrop-filter: blur(15px);\n  background-color: rgba(26, 91, 83, 0.16);\n  border-radius: 15px;\n  padding: 20px;\n}\n.signIn-form-container {\n  width: 100%;\n  padding: 3% 18% 0% 18%;\n}\n.signIn-form-label-color {\n  color: #ffffff;\n}\n.signIn-form-login_button {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.signIn-form-login_button_style {\n  margin-top: 30px;\n  width: 70%;\n  color: var(--app-primary-color);\n  font-size: 16px;\n}\n.signIn-form-login_text {\n  cursor: pointer;\n  color: #b5b5b5;\n  text-decoration: underline;\n}\n.signIn-form-login_forgot_text {\n  cursor: pointer;\n  color: #b5b5b5 !important;\n  text-decoration: underline !important;\n}\n.signIn-form-login_forgot_text:hover {\n  color: var(--app-secondary-color) !important;\n  cursor: pointer;\n  text-decoration: underline;\n}\n.signIn-form-login_forgot_text:active {\n  color: var(--app-secondary-color) !important;\n  cursor: pointer;\n  text-decoration: underline;\n}\n.adani-logo {\n  width: 120px;\n}\n.signIn_footer {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 1rem;\n  margin-top: -1rem;\n}\n.signIn_footer-text {\n  font-size: 14px;\n  font-weight: 600;\n}\n/* large mobile */\n@media only screen and (min-width: 600px) {\n  .signIn-img {\n    width: 70vh;\n    height: 76vh;\n  }\n  .signIn-container {\n    padding: 3% 0%;\n  }\n}\n/* small mobile */\n@media only screen and (min-width: 300px) and (max-width: 600px) {\n  .signIn-img {\n    width: 100%;\n    height: 100%;\n  }\n  .signIn-container {\n    padding: 20% 1%;\n  }\n  .signIn-form-card {\n    margin: 20px;\n  }\n  .signIn-container {\n    padding: 20% 0% 30% 0%;\n  }\n  .signIn-form-container {\n    padding: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"signIn-form": `index-module__signIn-form__IDQjg`,
	"signIn-description": `index-module__signIn-description__u7tes`,
	"version": `index-module__version__I5b2y`,
	"signIn-form__password": `index-module__signIn-form__password__L1g0c`,
	"signIn-btn": `index-module__signIn-btn__qNKud`,
	"forgot-password_div": `index-module__forgot-password_div__OwfBo`,
	"forgot-password-text": `index-module__forgot-password-text__GgDlJ`,
	"recaptcha-container": `index-module__recaptcha-container__RLebi`,
	"signIn-container": `index-module__signIn-container__NoMaT`,
	"signIn-img": `index-module__signIn-img__86wb7`,
	"signIn-form-logo-img": `index-module__signIn-form-logo-img__HQDP0`,
	"signIn-form-card": `index-module__signIn-form-card__EqlUE`,
	"signIn-form-container": `index-module__signIn-form-container__hei_d`,
	"signIn-form-label-color": `index-module__signIn-form-label-color__WhGVa`,
	"signIn-form-login_button": `index-module__signIn-form-login_button__WSbsP`,
	"signIn-form-login_button_style": `index-module__signIn-form-login_button_style__oYoTP`,
	"signIn-form-login_text": `index-module__signIn-form-login_text__AEDxc`,
	"signIn-form-login_forgot_text": `index-module__signIn-form-login_forgot_text__zfagw`,
	"adani-logo": `index-module__adani-logo__Ao0Rk`,
	"signIn_footer": `index-module__signIn_footer__eYVtO`,
	"signIn_footer-text": `index-module__signIn_footer-text__c6mRd`
};
export default ___CSS_LOADER_EXPORT___;
